import { render } from "./AlakaPage.vue?vue&type=template&id=0acbfa44&scoped=true"
import script from "./AlakaPage.vue?vue&type=script&lang=js"
export * from "./AlakaPage.vue?vue&type=script&lang=js"

import "./AlakaPage.vue?vue&type=style&index=0&id=0acbfa44&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0acbfa44"]])

export default __exports__